import React, { Component } from 'react'
import classNames from 'classnames';
import { mapToCssModules } from 'reactstrap/lib/utils';
import PropTypes from 'prop-types'
import { Card, CardBody, CardFooter, Button } from 'reactstrap';
import axios from 'axios';
import * as API_LINKS from '../../redux/config/links'
import {toast} from 'react-toastify';

const propTypes = {
    room: PropTypes.string,
    bed: PropTypes.string,
    code: PropTypes.string,
    id: PropTypes.number,
    status: PropTypes.number,
    icon: PropTypes.string,
    color: PropTypes.string,
}

const defaultProps = {
    room: 'Room A',
    bed: 'Bed 1',
    code: 'HS001',
    id: 1,
    status: 1,
    icon: 'fa fa-dashboard',
    color: 'danger',
}

class NurseWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {  };
    }

    fetchUpdate = (_code) => {
        var self = this;
        this.setState({
            isLoading: true
        })
        axios({
            method: 'post',
            url: API_LINKS.NURSE_ROOM_UPDATE_URL,
            data: {
                code: _code
            }
        })
        .then((response) => {
            if(response.status === 200) {
                self.props.updateData()
            }
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    self.setState({
                        isLoading: false
                    })
                    return toast.error(error.response.error.message);
                } else if (error.response.status === 403) {
                    self.setState({
                        isLoading: false
                    })
                    return toast.error(error.response.error.message);
                } else if (error.response.status === 400) {
                    self.setState({
                        isLoading: false
                    })
                    return toast.error(error.response.error.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    self.setState({
                        isLoading: false
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else {
                    self.setState({
                        isLoading: false
                    })
                    return toast.error('Something went wrong... Please try again later...')
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                // console.log(error.request);
                self.setState({
                    isLoading: false
                })
                return toast.error('Request error! Please try again later...')
            } else {
                // Something happened in setting up the request that triggered an Error
                self.setState({
                    isLoading: false
                })
                return toast.error('Something went wrong... Please try again later...')
                // return toast.error(error.message);
            }
        })
    }

    render() {
        const { room, bed, status, id, className, code, cssModule, icon, color, children, invert, ...attributes } = this.props;

        // demo purposes only
        const card = { style: '', bgColor: '', icon: icon };

        if (invert) {
            card.style = 'text-white';
            card.bgColor = 'bg-' + color;
        }

        const classes = mapToCssModules(classNames(className, card.style, card.bgColor), cssModule);

        return (
            <Card className={classes} {...attributes}>
                <CardBody>
                <div className="h1 text-muted text-right mb-2">
                    <i className={card.icon}></i>
                </div>
                <div className="h3 mb-0">{room}</div>
                <div className="h4 mb-0 text-muted">{bed}</div>
                <small className="text-muted text-uppercase font-weight-bold">{children}</small>
                {/* {this.checkStatus(status)} */}
                </CardBody>
                <CardFooter className="px-3 py-2" style={{'color': 'black'}}>
                    <Button className="font-weight-bold font-xs btn-block pull-right" onClick={() => this.fetchUpdate(code)} disabled={this.state.isLoading}>Acknowledge Call!
                    <i className="fa fa-angle-right float-right font-lg"></i></Button>
                </CardFooter>
            </Card>
        );
    }
}

NurseWidget.defaultProps = defaultProps;
NurseWidget.propTypes = propTypes;

export default NurseWidget;


// WEBPACK FOOTER //
// ./src/views/Nurse/NurseWidget.jsx